
<template>
        <div class="fixcon">
            <van-nav-bar :fixed='true'>
                     <template #title>
                        <span v-if="title!=''">{{title}}</span>
                     </template>
                     <template #left>
                        <van-icon name="arrow-left" size="18" @click="goback()" :color='color' v-if="showarrow"/>
                        <span v-else  @click="doLogout" class="quitcon">退出系统</span>
                     </template>
                     <template #right>
                        <slot name="rightcon">
                           <span @click="modifyPsw">修改密码</span>
                        </slot>
                     </template>
            </van-nav-bar>
            <van-dialog v-model="show" title="修改密码" show-cancel-button @confirm="handleConfirm">
               <van-form>
                  <van-field
                     v-model="password"
                     type="password"
                     name="新密码"
                     label="新密码"
                     placeholder="请输入新登陆密码"
                     
                  />
                  <van-field
                     v-model="repassword"
                     type="password"
                     name="重复密码"
                     label="再输入一次"
                     placeholder="请再输入一次新密码"
                     
                  />
               </van-form>
            </van-dialog>
        </div>
</template>
<script>
import { NavBar,Icon,Dialog,Form,Field } from 'vant';
export default {
   name: 'NavTop',
   data() {
      return {
          show:false,
          password:'',
          repassword:''
      }
   },
   props:{
      title:{type:String,default:''},
      color:{type:String,default:'#333333'},
      islink:{type:Boolean,default:false},
      linkurl:{type:String,default:'/index'},
      showarrow:{type:Boolean,default:true}
   },
   methods: {
      doLogout(){
        this.$store.commit("LOG_OUT")
        this.$go("/login")
      },
      goback() {
         if(this.islink){
            this.$go(this.linkurl)
         }else{
            this.$router.go(-1);
         } 
      },
      modifyPsw(){
         console.log("open...")
         this.show=true
      },
      handleConfirm(){
          if(this.password==""||this.repassword==""){
              this.$toast("密码不能为空")
              this.reset()
              return false
          }
          if(this.password!=this.repassword){
             this.$toast("两次密码输入不一致")
             this.reset()
              return false
          }

          this.$post("/index/modifyPsw",{password:this.password,repassword:this.repassword}).then((data)=>{
             if(data.result.success){
               this.$toast(data.result.info)
               this.$store.commit("LOG_OUT")
               this.$go("/login")
             }else{
                this.$toast(data.result.info)
                this.reset()
             }
         })

      },
      reset(){
         this.password=""
         this.repassword=""
         this.show=false
      }
   },
   components: {
      [Form.name]: Form,
      [Field.name]: Field,
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Dialog.Component.name]:Dialog.Component
   }
}
</script>
<style scoped>
.fixcon{height: 46px;margin-bottom: 10px;}   
::v-deep .van-search{position:fixed;width:100%;top:0;left:0;}
::v-deep .van-field__right-icon{display:flex;}
::v-deep [class*=van-hairline]::after{border: none;}
.quitcon{border:1px solid #ccc;border-radius: 5px;padding: 3px;}
</style>